// extracted by mini-css-extract-plugin
module.exports = {"container":"Office_container__1JYID","cards":"Office_cards__2Znwv","cardDetails":"Office_cardDetails__2bhL1"};